import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CapacitorSQLite, SQLiteConnection} from "@capacitor-community/sqlite";
import LocalDataSource from '../../../data-sources/LocalDataSource';
import { Pessoa } from 'src/app/domain/Pessoa';
import {DataSource} from "typeorm";

@Component({
    selector: 'app-header-hs1',
    templateUrl: './edicao.component.html',
    styleUrls: ['./edicao.component.scss']
})
export class HeaderComponent {
    @Input()
    titulo: string = ""

    @Input()
    deletavel: boolean = true

    @Input()
    editavel: boolean = true

    @Input()
    exibirBotoes: boolean = true

    @Output()
    eventSave = new EventEmitter();

    @Output()
    eventDelete = new EventEmitter();

    @Output()
    eventCancel = new EventEmitter();

    save(){ this.eventSave.emit()  }
    delete(){ this.eventDelete.emit() }

    cancelar(){ this.eventCancel.emit() }
}
